import $ from './jquery-3.2.1.min';
import conditions from './conditions';
import inhibitors from './inhibitors';
import treatments from './treatments';
import publicFunctions from './public-functions';
import variables from './variables';

// This function create the event listener for button actions
function btnsAction() {
  const body = document.getElementsByTagName('body')[0];
  const mainContainer = body.getElementsByClassName('main-container')[0];

  // This function validate that element selected is a button and have the class panel_btn or btn_treatments or the id btnNormal
  function validateTaget(e) {
    const isBtn = e.target.tagName === 'BUTTON' ? true : false
    const isValidBtn = e.target.classList.contains('panel_btn') || e.target.classList.contains('btn_treatments') || e.target.id === 'btnNormal' ? true : false;
    return isBtn && isValidBtn;
  }

  // Here listen when a element has been selected
  mainContainer.addEventListener('click', function (e) {
    const isValidTarget = validateTaget(e);

    // Checks if is a valid element selected
    if (isValidTarget) {
      $(".default-hidden").css({ "display": "none" });
      setDefaultTextInformation(e.target);
    }
    enableGoButton();
  });
}

// This function execute the resetConditionState function if the id received is in the arraylist
// function executeResetConditionState(id) {

//   // List of the id buttons that need execute resetConditionState function when one of them is clicked
//   const IdsToResetConditionState = ['btnOffset', 'btnNormal', 'btnHemA', 'btnHemB', 'btnvWD', 'btnHemA_LowTiter', 'btnHemA_HiTiter', 'btnHemB_LowTiter', 'btnHemB_HiTiter'];

//   //checks if the id received is in the arraylist
//   if (IdsToResetConditionState.indexOf(id) > -1) {
//     publicFunctions.resetConditionState();
//   }
// }

//This function set the correct information acording to the button selected
function setDefaultTextInformation(target) {

  //Always show all gears when the same or the new animation is selected
  //publicFunctions.showAllGears();
  // Reset timelines
  //publicFunctions.runNormal();
  //publicFunctions.resetTimelines();

  //This function execute the resetConditionState function if the id received is in the arraylist
  //executeResetConditionState(target.id);

  switch (target.id) {
    case 'btnOffset':
      publicFunctions.displayNoneOrBlockInfoDefault("block");
      publicFunctions.runOffset();
      break;
    case 'btnNormal':
      publicFunctions.displayNoneOrBlockInfoDefault("block");
      publicFunctions.runNormal();
      break;
    case 'btnHemA':
      setConditionSelectedValues(target, 'condition', 'btnHemA')
      publicFunctions.displayNoneOrBlockInfoDefault("none");
      showConditionButtons('inhibitor', 'btnHemA');
      //conditions.runHemA();
      break;
    case 'btnHemB':
      setConditionSelectedValues(target, 'condition', 'btnHemB')
      publicFunctions.displayNoneOrBlockInfoDefault("none");
      showConditionButtons('inhibitor', 'btnHemB');
      //conditions.runHemB();
      break;
    case 'btnvWD':
      setConditionSelectedValues(target, 'condition', 'btnvWD')
      publicFunctions.displayNoneOrBlockInfoDefault("none");
      showConditionButtons('inhibitor', 'btnvWD');
      //conditions.runvWD();
      break;
    case 'btn_NoTiter':
      setConditionSelectedValues(target, 'inhibitor', 'btn_NoTiter')
      showConditionButtons('treatment', 'btn_NoTiter');
      break;
    case 'btnHemA_LowTiter':
      setConditionSelectedValues(target, 'inhibitor', 'btnHemA_LowTiter')
      publicFunctions.displayNoneOrBlockInfoDefault("none");
      showConditionButtons('treatment', 'btnHemA_LowTiter');
      //inhibitors.runHemA_LowTiter();
      break;
    case 'btnHemA_HiTiter':
      setConditionSelectedValues(target, 'inhibitor', 'btnHemA_HiTiter')
      publicFunctions.displayNoneOrBlockInfoDefault("none");
      showConditionButtons('treatment', 'btnHemA_HiTiter');
      //inhibitors.runHemA_HiTiter();
      break;
    case 'btnHemB_LowTiter':
      setConditionSelectedValues(target, 'inhibitor', 'btnHemB_LowTiter')
      publicFunctions.displayNoneOrBlockInfoDefault("none");
      showConditionButtons('treatment', 'btnHemB_LowTiter');
      //$("#info-hemBLow").css({ "display": "block" });
      //inhibitors.runHemB_LowTiter();
      break;
    case 'btnHemB_HiTiter':
      setConditionSelectedValues(target, 'inhibitor', 'btnHemB_HiTiter')
      publicFunctions.displayNoneOrBlockInfoDefault("none");
      showConditionButtons('treatment', 'btnHemB_HiTiter');
      //$("#info-hemBHigh").css({ "display": "block" });
      //inhibitors.runHemB_HiTiter();
      break;
    case 'btnTrmtAaRF':
      setConditionSelectedValues(target, 'treatment', 'btnTrmtAaRF')
      publicFunctions.displayNoneOrBlockInfoDefault("none");
      $("#info-hemA-rf").css({ "display": "block" });
      var divHeight = $("#info-hemA-rf").outerHeight()
      $("#info-center").css({ "height": divHeight + 100 });
      $("#info-center_toggle").css({ "top": divHeight + 88 })
      //runTrmtAaRF doesn't display a extra border 
      //treatments.runTrmtAaRF(false);
      break;
    case 'btnTrmtALoRF':
      setConditionSelectedValues(target, 'treatment', 'btnTrmtALoRF')
      publicFunctions.displayNoneOrBlockInfoDefault("none");
      $("#info-hemALow-rf").css({ "display": "block" });
      var divHeight = $("#info-hemALow-rf").outerHeight()
      $("#info-center").css({ "height": divHeight + 100 });
      $("#info-center_toggle").css({ "top": divHeight + 88 })
      //runTrmtAaRF display a extra border 
      //treatments.runTrmtAaRF(true);
      break;
    case 'btnTrmtAHiAPCC':
      setConditionSelectedValues(target, 'treatment', 'btnTrmtAHiAPCC')
      publicFunctions.displayNoneOrBlockInfoDefault("none");
      $("#info-hemAHigh-apcc").css({ "display": "block" });
      var divHeight = $("#info-hemAHigh-apcc").outerHeight()
      $("#info-center").css({ "height": divHeight + 100 });
      $("#info-center_toggle").css({ "top": divHeight + 88 })
      //treatments.runTrmtAHiAPCC();
      break;
    case 'btnTrmtAHiFVIIIa':
      setConditionSelectedValues(target, 'treatment', 'btnTrmtAHiFVIIIa')
      publicFunctions.displayNoneOrBlockInfoDefault("none");
      $("#info-hemAHigh-fviia").css({ "display": "block" });
      var divHeight = $("#info-hemAHigh-fviia").outerHeight()
      $("#info-center").css({ "height": divHeight + 100 });
      $("#info-center_toggle").css({ "top": divHeight + 88 })
      //treatments.runTrmtAHiFVIIIa();
      break;
    case 'btnTrmtBaRF':
      setConditionSelectedValues(target, 'treatment', 'btnTrmtBaRF')
      publicFunctions.displayNoneOrBlockInfoDefault("none");
      $("#info-hemB-rf").css({ "display": "block" });
      var divHeight = $("#info-hemB-rf").outerHeight()
      $("#info-center").css({ "height": divHeight + 100 });
      $("#info-center_toggle").css({ "top": divHeight + 88 })
      //runTrmtBaRF doesn't display a extra border 
      //treatments.runTrmtBaRF(false);
      break;
    case 'btnTrmtBLoRF':
      setConditionSelectedValues(target, 'treatment', 'btnTrmtBLoRF')
      publicFunctions.displayNoneOrBlockInfoDefault("none");
      $("#info-hemBLow-rf").css({ "display": "block" });
      var divHeight = $("#info-hemBLow-rf").outerHeight()
      $("#info-center").css({ "height": divHeight + 100 });
      $("#info-center_toggle").css({ "top": divHeight + 88 })
      //runTrmtBaRF display a extra border 
      //treatments.runTrmtBaRF(true);
      break;
    case 'btnTrmtBHiAPCC':
      setConditionSelectedValues(target, 'treatment', 'btnTrmtBHiAPCC')
      publicFunctions.displayNoneOrBlockInfoDefault("none");
      $("#info-hemBHigh-apcc").css({ "display": "block" });
      var divHeight = $("#info-hemBHigh-apcc").outerHeight()
      $("#info-center").css({ "height": divHeight + 100 });
      $("#info-center_toggle").css({ "top": divHeight + 88 })
      //treatments.runTrmtBHiAPCC();
      break;
    case 'btnTrmtBHiFVIIIa':
      setConditionSelectedValues(target, 'treatment', 'btnTrmtBHiFVIIIa')
      publicFunctions.displayNoneOrBlockInfoDefault("none");
      $("#info-hemBHigh-fviia").css({ "display": "block" });
      var divHeight = $("#info-hemBHigh-fviia").outerHeight()
      $("#info-center").css({ "height": divHeight + 100 });
      $("#info-center_toggle").css({ "top": divHeight + 88 })
      //treatments.runTrmtBHiFVIIIa();
      break;
    case 'btnTrmtDesmopressin':
      setConditionSelectedValues(target, 'treatment', 'btnTrmtDesmopressin')
      publicFunctions.displayNoneOrBlockInfoDefault("none");
      $("#info-vWD-desmopressin").css({ "display": "block" });
      var divHeight = $("#info-vWD-desmopressin").outerHeight()
      $("#info-center").css({ "height": divHeight + 100 });
      $("#info-center_toggle").css({ "top": divHeight + 88 })
      //treatments.runTrmtDesmopressin();
      break;
    case 'btnTrmtvW':
      setConditionSelectedValues(target, 'treatment', 'btnTrmtvW')
      publicFunctions.displayNoneOrBlockInfoDefault("none");
      $("#info-vWD-vWF").css({ "display": "block" });
      var divHeight = $("#info-vWD-vWF").outerHeight()
      $("#info-center").css({ "height": divHeight + 100 });
      $("#info-center_toggle").css({ "top": divHeight + 88 })
      //runTrmtvW doesn't display a extra border 
      //treatments.runTrmtvW(false);
      break;
    case 'btnTrmtvWFVIII':
      setConditionSelectedValues(target, 'treatment', 'btnTrmtvWFVIII')
      publicFunctions.displayNoneOrBlockInfoDefault("none");
      $("#info-vWD-vWFFVIII").css({ "display": "block" });
      var divHeight = $("#info-vWD-vWFFVIII").outerHeight()
      $("#info-center").css({ "height": divHeight + 100 });
      $("#info-center_toggle").css({ "top": divHeight + 88 })
      //runTrmtvW display a extra border 
      //treatments.runTrmtvW(true);
      break;
  }
  publicFunctions.setInfoBoxtoTop();
}



// set condition variable values and toggle the style for selected button: target(button) type(condition or inhibitor) name(name of the condition)
function setConditionSelectedValues(target, type, name) {
  var arr = Array.prototype.slice.call(target.parentNode.children).filter(x => x.classList.contains('panel_btn--selected'))
  arr.forEach(element => {
    element.classList.remove('panel_btn--selected');
  });
  target.classList.toggle('panel_btn--selected');
  if (target.classList.contains('panel_btn--selected')) {
    switch (type){
      case 'condition':
        variables.conditionSelected.condition = name;
        variables.conditionSelected.inhibitor = '';
        variables.conditionSelected.treatment = '';
        break;
      case 'inhibitor':
        variables.conditionSelected.inhibitor = name;
        variables.conditionSelected.treatment = '';
        break;
      case 'treatment':
        variables.conditionSelected.treatment = name;
        break;
    }
  }
  else {
    switch (type){
      case 'condition':
        variables.conditionSelected.condition = '';
        break;
      case 'inhibitor':
        variables.conditionSelected.inhibitor = '';
        break;
      case 'treatment':
        variables.conditionSelected.treatment = '';
        break;
    }
  }
}

let showConditionButtons = (type, name) => {
  let elements_to_show, elements_to_hide;
  if (type === 'inhibitor'){
    publicFunctions.unselectAllInhibitors();
    publicFunctions.unselectAllTreatments();
    switch(name){
      case 'btnHemA':
        // This funtions hide the buttons not needed
        publicFunctions.hideAllInhibitors();
        publicFunctions.hideAllTreatments();

        // This funtion shows elements given by ID
        elements_to_show = ['panel_inhibitors-section','btnHemA_LowTiter','btnHemA_HiTiter','btn_NoTiter', 'info-hemA'];
        publicFunctions.showElements(elements_to_show);
        var divHeight = $("#info-hemA").outerHeight()
        $("#info-center").css({ "height": divHeight + 100 });
        $("#info-center_toggle").css({ "top": divHeight + 88 })
        break;
      case 'btnHemB':
        // This funtions hide the buttons not needed
        publicFunctions.hideAllInhibitors();
        publicFunctions.hideAllTreatments();

        // This funtion shows elements given by ID
	      elements_to_show = ['panel_inhibitors-section','btnHemB_LowTiter','btnHemB_HiTiter','btn_NoTiter', 'info-hemB'];
        publicFunctions.showElements(elements_to_show);  
        
        var divHeight = $("#info-hemB").outerHeight()
        $("#info-center").css({ "height": divHeight + 100 });
        $("#info-center_toggle").css({ "top": divHeight + 88 })
        break;
      case 'btnvWD': 
        // This funtions hide the buttons not needed
        publicFunctions.hideAllInhibitors();
        publicFunctions.hideAllTreatments();
        elements_to_hide = ['panel_inhibitors-section'];
        publicFunctions.hideElements(elements_to_hide);

        // This funtion shows elements given by ID
        elements_to_show = ['btnTrmtvW', 'btnTrmtDesmopressin', 'btnTrmtvWFVIII','info-vWD'];
        publicFunctions.showElements(elements_to_show);

        var divHeight = $("#info-vWD").outerHeight()
        $("#info-center").css({ "height": divHeight + 100 });
        $("#info-center_toggle").css({ "top": divHeight + 88 })
        break;
    } 
  }
  if (type === 'treatment'){
    publicFunctions.unselectAllTreatments();
    switch(name){
      case 'btn_NoTiter': 
        publicFunctions.hideAllTreatments();
        switch(variables.conditionSelected.condition){
          case 'btnHemA':
            elements_to_show = ['btnTrmtAaRF','info-hemA'];
            var divHeight = $("#info-hemA").outerHeight()
            $("#info-center").css({ "height": divHeight + 100 });
            $("#info-center_toggle").css({ "top": divHeight + 88 })
            break;
          case 'btnHemB':
            elements_to_show = ['btnTrmtBaRF','info-hemB'];
            var divHeight = $("#info-hemB").outerHeight()
            $("#info-center").css({ "height": divHeight + 100 });
            $("#info-center_toggle").css({ "top": divHeight + 88 })
            break;
        }
        // This funtion shows elements given by ID     
        publicFunctions.showElements(elements_to_show);
        break;
      case 'btnHemA_LowTiter':
        publicFunctions.hideAllTreatments();
        elements_to_show = ['btnTrmtALoRF', 'info-hemALow'];
        publicFunctions.showElements(elements_to_show); 
        var divHeight = $("#info-hemALow").outerHeight()
        $("#info-center").css({ "height": divHeight + 100 });
        $("#info-center_toggle").css({ "top": divHeight + 88 })
        break;
      case 'btnHemA_HiTiter': 
        publicFunctions.hideAllTreatments();
        elements_to_show = ['btnTrmtAHiAPCC','btnTrmtAHiFVIIIa', 'info-hemAHigh'];
        publicFunctions.showElements(elements_to_show); 
        var divHeight = $("#info-hemAHigh").outerHeight()
        $("#info-center").css({ "height": divHeight + 100 });
        $("#info-center_toggle").css({ "top": divHeight + 88 })
        break;
      case 'btnHemB_LowTiter': 
        publicFunctions.hideAllTreatments();
        elements_to_show = ['btnTrmtBLoRF', 'info-hemBLow'];
        publicFunctions.showElements(elements_to_show);
        var divHeight = $("#info-hemBLow").outerHeight()
        $("#info-center").css({ "height": divHeight + 100 });
        $("#info-center_toggle").css({ "top": divHeight + 88 })
        break;
      case 'btnHemB_HiTiter': 
        publicFunctions.hideAllTreatments();
        elements_to_show = ['btnTrmtBHiAPCC','btnTrmtBHiFVIIIa', 'info-hemBHigh'];
        publicFunctions.showElements(elements_to_show); 
        var divHeight = $("#info-hemBHigh").outerHeight()
        $("#info-center").css({ "height": divHeight + 100 });
        $("#info-center_toggle").css({ "top": divHeight + 88 })
        break;
    }
  }
}

let enableGoButton = () => {
  let buttonsClicked = variables.conditionSelected;
		if (buttonsClicked.condition === 'btnvWD' || 
		   (buttonsClicked.condition !== 'btnvWD' && buttonsClicked.inhibitor !== '')){
        $('.panel_go-btn .gear').css({'cursor':'pointer','color':'#848181'});
        $('.panel_go-btn .gear svg').css('fill','#00C5AE');
        $('.panel_go-btn .gear circle').css('stroke','#00C5AE');
		} else {
        $('.panel_go-btn .gear').css({'cursor':'','color':''});
        $('.panel_go-btn .gear svg').css('fill','');
        $('.panel_go-btn .gear circle').css('stroke','');
    }
}

switchUpArrow.onclick = function () {
  publicFunctions.showControlsPanel();
}

switchDownArrow.onclick = function () {
  publicFunctions.hideControlsPanel();
}

document.querySelector('.panel_go-btn .gear').onclick = publicFunctions.startGearsAnimation;

document.querySelector('.skip_intro').onclick = publicFunctions.hideWelcomeModal;
document.querySelector('.btn-carrousel--start').onclick = publicFunctions.hideWelcomeModal;

document.querySelector('.btn-welcome_start').onclick = publicFunctions.startWelcomeCarrousel;

document.querySelector('.btn-carrousel--back').onclick = publicFunctions.moveWelcomeCarrousel;

document.querySelector('.btn-carrousel--next').onclick = publicFunctions.moveWelcomeCarrousel;

$('#info-center strong').click(publicFunctions.showInfoModal);
$('.welcome-carrousel strong').click(publicFunctions.showInfoModal);

document.querySelector('.modal-info_close').onclick = publicFunctions.hideInfoModal;

document.querySelector('.gears-options-box .close').onclick = publicFunctions.hideOptionsBox;
document.querySelector('.options .info').onclick = publicFunctions.showGearOptionsInfo;

document.querySelector('.infobox-toggle-btn').onclick = publicFunctions.toggleInfoBox;


//-------- Gears Select Events --------//
variables.factor_12.onclick = publicFunctions.showGearOptionsInfo;
variables.factor_11.onclick = publicFunctions.showGearOptionsInfo;
variables.factor_09.onclick = publicFunctions.showGearOptionsInfo;
variables.factor_07a.onclick = publicFunctions.showGearOptionsInfo;
variables.factor_08.onclick = publicFunctions.showGearOptionsInfo;
variables.factor_vW.onclick = publicFunctions.showGearOptionsInfo;
variables.factor_10.onclick = publicFunctions.showGearOptionsInfo;
variables.factor_05a.onclick = publicFunctions.showGearOptionsInfo;
variables.factor_02a .onclick = publicFunctions.showGearOptionsInfo;
variables.factor_01a.onclick = publicFunctions.showGearOptionsInfo;
variables.factor_13a.onclick = publicFunctions.showGearOptionsInfo;
variables.factor_CLOT.onclick = publicFunctions.showGearOptionsInfo;
document.querySelector('#factor_replacement_08').onclick = publicFunctions.showGearOptionsInfo;
document.querySelector('#factor_replacement_09').onclick = publicFunctions.showGearOptionsInfo;
document.querySelector('#factor_replacement_vW').onclick = publicFunctions.showGearOptionsInfo;


//-------- Sidebar Events --------//
document.querySelector('.btn-sidebar--home').onclick = () =>{  };
document.querySelector('.btn-sidebar--info').onclick = publicFunctions.showWelcomeModal;
document.querySelector('.btn-sidebar--replay').onclick = publicFunctions.refreshAnimations;
document.querySelector('.btn-sidebar--book').onclick = publicFunctions.showGlossaryModal;
document.querySelector('.modal-glossary_close').onclick = publicFunctions.hideGlossaryModal;

//-------- Glossary Modal Events --------//
document.querySelector('.glossary-nav--back').onclick = publicFunctions.changeGlossaryPage;
document.querySelector('.glossary-nav--next').onclick = publicFunctions.changeGlossaryPage;

export default btnsAction;




// WEBPACK FOOTER //
// ./src/js/events.js